module.exports = __webpack_public_path__ + "img/xz.8dc8c378.jpg";